module.exports = __webpack_public_path__ + "img/mx_seguromultidispositivo.66cb9c45.png";